<template>
  <VueDialog :dialog-data="dialogData">
    <vue-table :table-data="tableData" size="mini">
      <template slot="openid" slot-scope="{row}">
        {{row.openid ? "是" : "否"}}
      </template>
    </vue-table>
  </VueDialog>
</template>

<script>
  import {adminType} from "@utils/formatList"
  export default {
    name: "AdminInfo",
    props: {dialogData: Object},
    data() {
      return {
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "账号", property: "username"},
            {label: "姓名", property: "name"},
            {label: "手机号", property: "mobile"},
            {label: "邮箱", property: "email"},
            // {label: "微信绑定", property: "openid", width: 70},
            {label: "账号类型", property: "is_admin", format: adminType, width: 70},
          ],
        }
      }
    },
    methods: {
      async getData() {
        let res = await this.$Http.getShopAccountList({shop_id: this.dialogData.row.id});
        if (res) {
          this.tableData.tableList = res.data.list || [];
        }
      }
    },
    created() {
      this.getData();
    }
  }
</script>

<style scoped>

</style>
